import { ref } from 'vue';
import { defineStore } from 'pinia';
import type { FormValues } from '~/types/form-schema';

export const useRegistrationStore = defineStore('registration', () => {
  const registrationData = ref<FormValues>({});
  const hasCustomizeStep = ref<boolean>(false);

  function setRegistrationData(data: FormValues): void {
    registrationData.value = { ...registrationData.value, ...data };
  }

  function resetStore(): void {
    registrationData.value = {};
  }

  return {
    registrationData,
    hasCustomizeStep,
    setRegistrationData,
    resetStore,
  };
}, {
  persist: true,
});
